// document.addEventListener('DOMContentLoaded', function () {
//   const heading = document.querySelector('.title.title--primary');

//   if (heading && heading.textContent.includes('No products found')) {
//     // Hide everything after "No products found"
//     heading.innerHTML = 'No products found';
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  setInterval(function () {
    const heading = document.querySelector('.title.title--primary');

    if (heading && heading.textContent.includes('No products found')) {
      heading.textContent = 'No products found';
    }
  }, 500);
});




const dropdownItems = document.querySelectorAll('.dropdown_item');

function handleInteraction() {
  const isDesktop = window.innerWidth >= 1024;

  dropdownItems.forEach(item => {
    const btn = item.querySelector('.dropdown_item_btn');

    // Remove previous listeners (important when resizing)
    item.replaceWith(item.cloneNode(true));
  });

  const updatedItems = document.querySelectorAll('.dropdown_item');

  updatedItems.forEach(item => {
    const btn = item.querySelector('.dropdown_item_btn');

    if (isDesktop) {
      // HOVER for desktop
      item.addEventListener('mouseenter', () => {
        document.querySelectorAll('.dropdown_item_btn').forEach(b => {
          b.classList.remove('active');
        });
        btn.classList.add('active');
      });
    } else {
      // CLICK for mobile/tablet
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelectorAll('.dropdown_item_btn').forEach(b => {
          b.classList.remove('active');
        });
        btn.classList.add('active');
      });
    }
  });
}

// Run on load
handleInteraction();

// Run on resize
window.addEventListener('resize', handleInteraction);
document.addEventListener("DOMContentLoaded", () => {

  // Set first item active by default
  const firstItem = document.querySelector('.dropdown_item');
  if (firstItem) {
    const btn = firstItem.querySelector('.dropdown_item_btn');
    if (btn) btn.classList.add('active');
  }

  const menuToggle = document.getElementById("menuToggle");
  const navLinks = document.getElementById("navLinks");
  const dropdownLists = document.querySelectorAll(".dropdown_list");

  // Toggle main menu
  if (menuToggle && navLinks) {
    menuToggle.addEventListener("click", () => {
      menuToggle.classList.toggle("active");
      navLinks.classList.toggle("active");
    });
  }

  // Dropdown toggle (mobile only)
  dropdownLists.forEach((dropdown) => {
    const toggle = dropdown.querySelector(".dropdown_toggle");

    if (!toggle) return;

    toggle.addEventListener("click", (e) => {
      if (window.innerWidth < 1024) {
        e.preventDefault();
        e.stopPropagation();

        // Close other dropdowns
        dropdownLists.forEach((item) => {
          if (item !== dropdown) {
            item.classList.remove("active");
          }
        });

        // Toggle current dropdown
        dropdown.classList.toggle("active");
      }
    });
  });

});

window.addEventListener("scroll", function () {
  const header = document.getElementById("nav_header");

  if (window.scrollY > 100) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
});


$('.brandlogo_carousel').owlCarousel({
  loop: true,
  autoplay: true,
  nav: false,
  dots: false,
  slideTransition: 'linear',
  autoplayTimeout: 2000,
  autoplaySpeed: 4000,
  smartSpeed: 4000,
  autoplayHoverPause: false,
  responsive: {
    0: {
      margin: 50,
      items: 2,
    },
    400: {
      margin: 50,
      items: 3,
    },
    600: {
      margin: 50,
      items: 4,
    },
    768: {
      margin: 80,
      items: 5,
    },
    1000: {
      margin: 170,
      items: 5,
    }
  }
});

$('.favourites_carousel').owlCarousel({
  loop: true,
  autoplay: true,
  stagePadding: 15,
  margin: 20,
  nav: false,
  dots: false,
  responsive: {
    0: {
      items: 1,
      stagePadding: 0,
    },
    550: {
      items: 2,
    },
    991: {
      items: 3,
    },
    1200: {
      items: 4,
    },
    1440: {

      items: 5,
    }
  }
});


const marquees = document.querySelectorAll(".marqueeText");

marquees.forEach((marquee) => {

  marquee.innerHTML += marquee.innerHTML;

  let position = 0;
  const speed = 2;

  function animateMarquee() {
    position -= speed;

    if (Math.abs(position) >= marquee.scrollWidth / 2) {
      position = 0;
    }

    marquee.style.transform = `translateX(${position}px)`;

    requestAnimationFrame(animateMarquee);
  }

  animateMarquee();
});

$('.whats_trending_carousel').owlCarousel({
  loop: true,
  autoplay: true,
  statePadding: 10,
  nav: true,
  dots: false,
  margin: 20,
  navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
  responsive: {
    0: {
      items: 1,
    },
    1200: {
      items: 2,
    },
  }
});


$('.as_seen_carousel').owlCarousel({
  loop: true,
  autoplay: true,
  statePadding: 10,
  nav: true,
  dots: false,
  margin: 25,
  navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
  responsive: {
    0: {
      items: 1,
    },
    700: {
      items: 2,
    },
    991: {
      items: 3,
    },
    1320: {
      items: 4,
    },
  }
});

$('.testimonials_carousel').owlCarousel({
  loop: true,
  autoplay: true,
  stagePadding: 10,
  nav: false,
  dots: false,
  center: true,
  margin: 40,
  navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
  responsive: {
    0: {
      items: 1,
    },
    767: {
      items: 1.5,
    },
    991: {
      items: 2,
    },
  }
});

const filterBtns = document.querySelectorAll('.filter_btn');
const listFilters = document.querySelectorAll('.list_filter');
const listingTps = document.querySelectorAll('.listing_tp');

/* Make all active by default */
filterBtns.forEach((btn, index) => {
  btn.classList.add('active');

  if (listFilters[index]) {
    listFilters[index].classList.add('active');
  }

  if (listingTps[index]) {
    listingTps[index].classList.add('active');
  }
});

/* Toggle on click */
filterBtns.forEach((btn, index) => {
  btn.addEventListener('click', () => {

    btn.classList.toggle('active');

    if (listFilters[index]) {
      listFilters[index].classList.toggle('active');
    }

    if (listingTps[index]) {
      listingTps[index].classList.toggle('active');
    }

  });
});

// Range Slider 
var $range = $(".js-range-slider"),
  $from = $(".from"),
  $to = $(".to"),
  from,
  to;

function formatCurrency(val) {
  return "£" + parseFloat(val).toFixed(2);
}

$range.ionRangeSlider({
  type: "double",
  min: 0,
  max: 3000,
  from: 0,
  to: 3000,

  onStart: function (data) {
    $from.val(formatCurrency(data.from));
    $to.val(formatCurrency(data.to));
  },

  onChange: function (data) {
    $from.val(formatCurrency(data.from));
    $to.val(formatCurrency(data.to));
  }
});


var thumbSwiper = new Swiper(".thumbSwiper", {
  direction: "vertical",
  spaceBetween: 10,
  slidesPerView: 7,
  breakpoints: {
    0: {
      slidesPerView: 4,
    },
    576: {
      direction: "vertical",
      slidesPerView: 5,
    },
    1200: {
      slidesPerView: 7,
    },
  },
});

var mainSwiper = new Swiper(".mainSwiper", {
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 32,
  mousewheel: false,
  thumbs: {
    swiper: thumbSwiper
  },

});

const minusBtn = document.querySelector('.minus');
const plusBtn = document.querySelector('.plus');
const qtyInput = document.querySelector('.qty__input');

minusBtn.addEventListener('click', () => {
  let value = parseInt(qtyInput.value);
  if (value > 1) {
    qtyInput.value = value - 1;
  }
});

plusBtn.addEventListener('click', () => {
  let value = parseInt(qtyInput.value);
  qtyInput.value = value + 1;
});


const sliders = document.querySelectorAll(".range-slider");

sliders.forEach(slider => {

  function updateSlider() {
    const value = (slider.value - slider.min) / (slider.max - slider.min) * 100;
    slider.style.background =
      `linear-gradient(to right, #CEACD0 ${value}%, rgba(0, 0, 0, 0.20) ${value}%)`;
  }

  slider.addEventListener("input", updateSlider);
  updateSlider();

});




